import { touchSwipeDetection } from './index.js';

const defaultConfig = {
  containerClass: '.carousel',
  slidesClass: '.slides',
  slideClass: '.slide',
  currentSlideClass: '.slide--current',
  nextClass: '.carousel__next',
  prevClass: '.carousel__prev',
  currentPageClass: false,
  currentSlideProgressClass: false,
  autoSlideTimer: false,
  grouped: false,
  slideAnimations: false,
  fixHeight: false
};

export default (config = {}) => {
  // config
  const { containerClass, slidesClass, slideClass, currentSlideClass, nextClass, prevClass, currentPageClass, currentSlideProgressClass, autoSlideTimer, grouped, slideAnimations, fixHeight } = Object.assign(defaultConfig, config);

  let sliderInterval = null;
  let swiper = [];
  
  const setFirstSlideAsCurrent = () => [...document.querySelectorAll(containerClass)].map(el => [...el.querySelectorAll(slideClass)].map((slide, i) => {
    if (slideAnimations) slide.style.transform = 'translateX(-100%)';
    if (grouped ? i <= grouped : i === 0) {
      slide.classList.add(currentSlideClass.replace('.', ''));
      if (grouped) slide.style.transform = `translateX(${100 * i}%)`;
    }

    if (document.querySelector('.carousel__progress-bar')) {
      document.querySelector(".carousel__progress-bar").style.animation = 'none';
      document.querySelector(".carousel__progress-bar").offsetHeight;
      document.querySelector(".carousel__progress-bar").style.animation = '';
    }
  }));

  const runFixHeight = () => {
    [...document.querySelectorAll(containerClass)].map(el => {
      const heights = [...el.querySelectorAll(slideClass)].map((slide, i) => slide.getBoundingClientRect().height).sort();
      setTimeout(() => (el.querySelector(slidesClass).style.minHeight = heights[heights.length - 1] + 'px'), 500);
    });
  };

  // Swipe Event:
  const addSwipeEvent = () => [...document.querySelectorAll(containerClass)].map(el => touchSwipeDetection({ surface: el, threshold: 50 }, swipeEvent(el)));

  const swipeEvent = (container) => (dir) => {
    const slides = getSlides(container);
    const currentIndex = getCurrentIndex(slides);

    switch (dir) {
    case 'left': return nextSlide(slides, currentIndex);
    case 'right': return prevSlide(slides, currentIndex);
    default: 
    }
  };
  
  // Helper
  const getSlides = (container) => [...container.querySelector(slidesClass).querySelectorAll(slideClass)].map(el => ({ el, current: el.matches(currentSlideClass) }));
  const getContainer = ({ target }) => target.closest(containerClass);
  const getCurrentIndex = slides => {
    const current = slides.map(slide => slide.current);
    
    if (grouped) {
      const currents = current.map((slide, i) => slide ? i : false).filter(i => i !== false);
      const test = currents.map((n, i, arr) => (n - arr[i === 0 ? (arr.length - 1) : i - 1] > 1) ? n : -1).filter(n => n > -1);
      if (test.length) return test[0];
      return currents[0];
    }
    
    return current.indexOf(true);
  };
  
  const updateSlidePagination = (el, value) => (el.innerHTML = `${value}`.padStart(2, '0'));
  const getCurrentPageEl = slides => slides[0].el.closest(containerClass).querySelector(currentPageClass);  
  const triggerEvent = (container, event) => container.dispatchEvent(new Event(event, { bubbles: true }));

  const nextSlide = (slides, currentIndex) => {
    const currentPageEl = getCurrentPageEl(slides);

    if (grouped) {
      const currentIndices = new Array(grouped).fill(1).map((a, i) => (currentIndex + i > slides.length - 1 ? 1 + currentIndex + i - slides.length : 1 + currentIndex + i));
      const nextIndices = currentIndices.map(n => n + 1 > slides.length ? 1 : n + 1);
    
      const nextIndex1 = currentIndices[currentIndices.length - 1] + 1 <= slides.length ? currentIndices[currentIndices.length - 1] + 1 : (currentIndices[currentIndices.length - 1] + 1) % slides.length;
      const nextIndex2 = nextIndices[nextIndices.length - 1] + 1 <= slides.length ? nextIndices[nextIndices.length - 1] + 1 : (nextIndices[nextIndices.length - 1] + 1) % slides.length;
      // const prevIndices = currentIndices.map(n => n - 1 > 0 ? n - 1 : (slides.length - 1) + n);

      slides.map((slide, i) => {
        if (currentIndices.includes(i + 1)) slide.el.classList.remove(currentSlideClass.replace('.', ''));
        if (nextIndices.includes(i + 1)) {
          slide.el.classList.add(currentSlideClass.replace('.', ''));
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * nextIndices.indexOf(i + 1)}%)`;
        } else if ((i + 1) === nextIndex2) {
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * (nextIndices.length)}%)`;
        } else if ((i + 1) === nextIndex1) {
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * (nextIndices.length)}%)`;
        } else {
          if (slideAnimations) slide.el.style.transform = 'translateX(-100%)';
        }
      });
      
      if (currentPageEl) updateSlidePagination(currentPageEl, nextIndices[0]);
    } else {
      const nextSlideIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;

      slides.map((slide, i) => {
        if (i === currentIndex) return slide.el.classList.remove(currentSlideClass.replace('.', ''));
        if (i === nextSlideIndex) return slide.el.classList.add(currentSlideClass.replace('.', ''));
      });
      
      if (currentPageEl) updateSlidePagination(currentPageEl, nextSlideIndex + 1);
    }

    if (document.querySelector('.carousel__progress-bar')) {
      document.querySelector(".carousel__progress-bar").style.animation = 'none';
      document.querySelector(".carousel__progress-bar").offsetHeight;
      document.querySelector(".carousel__progress-bar").style.animation = '';
    }

    triggerEvent(getContainer({ target: slides[0].el }), 'slider:next');
    triggerEvent(getContainer({ target: slides[0].el }), 'slider:change');
  };

  const prevSlide = (slides, currentIndex) => {
    const currentPageEl = getCurrentPageEl(slides);

    if (grouped) {
      const currentIndices = new Array(grouped).fill(1).map((a, i) => (currentIndex + i > slides.length - 1 ? 1 + currentIndex + i - slides.length : 1 + currentIndex + i));
      const nextIndices = currentIndices.map(n => n + 1 > slides.length ? 1 : n + 1);
      const prevIndices = currentIndices.map(n => n - 1 > 0 ? n - 1 : (slides.length - 1) + n);

      const nextIndex1 = ((prevIndices[prevIndices.length - 1] + 1) % slides.length) === 0 ? slides.length : ((prevIndices[prevIndices.length - 1] + 1) % slides.length);
      const nextIndex2 = ((currentIndices[currentIndices.length - 1] + 1) % slides.length);
      
      slides.map((slide, i) => {
        if (currentIndices.includes(i + 1)) slide.el.classList.remove(currentSlideClass.replace('.', ''));
        if (prevIndices.includes(i + 1)) {
          slide.el.classList.add(currentSlideClass.replace('.', ''));
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * prevIndices.indexOf(i + 1)}%)`;
        } else if ((i + 1) === nextIndex1) {
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * (prevIndices.length)}%)`;
        } else if ((i + 1) === nextIndex2) {
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * (prevIndices.length)}%)`;
        } else {
          if (slideAnimations) slide.el.style.transform = `translateX(${100 * -1}%)`;
        }
      });

      if (currentPageEl) updateSlidePagination(currentPageEl, prevIndices[0]);
    } else {
      const prevSlideIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
          
      slides.map((slide, i) => {
        if (i === currentIndex) return slide.el.classList.remove(currentSlideClass.replace('.', ''));
        if (i === prevSlideIndex) return slide.el.classList.add(currentSlideClass.replace('.', ''));
      });

      if (currentPageEl) updateSlidePagination(currentPageEl, prevSlideIndex + 1);
    }

    if (document.querySelector('.carousel__progress-bar')) {
      document.querySelector(".carousel__progress-bar").style.animation = 'none';
      document.querySelector(".carousel__progress-bar").offsetHeight;
      document.querySelector(".carousel__progress-bar").style.animation = '';
    }
    
    triggerEvent(getContainer({ target: slides[0].el }), 'slider:previous');
    triggerEvent(getContainer({ target: slides[0].el }), 'slider:change');
  };

  const nextSlideClick = (e) => {
    const slides = getSlides(getContainer(e));
    const currentIndex = getCurrentIndex(slides);

    console.log('Current Index: ', currentIndex);

    return nextSlide(slides, currentIndex);
  };

  const previousSlideClick = (e) => {
    const slides = getSlides(getContainer(e));
    const currentIndex = getCurrentIndex(slides);

    return prevSlide(slides, currentIndex);
  };

  const animationNextSlide = e => {
    if (!e.target.matches(`${containerClass} ${currentSlideProgressClass}`)) return;
  
    const container = getContainer(e);
    const slides = getSlides(container);
    const currentIndex = getCurrentIndex(slides);

    if (slides.length > 1) nextSlide(slides, currentIndex);
  };
  
  const initialiseSliders = e => {
    const container = document.querySelector(containerClass);

    // [...document.querySelectorAll(`${containerClass} ${slidesClass} ${currentSlideClass}`)].map(slide => slide.classList.remove(currentSlideClass.replace('.', '')));
    let preActive = [...document.querySelectorAll(`${containerClass} ${slidesClass} ${currentSlideClass}`)];

    // if (preActive.length > 1) {
    //   console.log(preActive.slice(0, -1));
    // }

    console.log(preActive);
    if (preActive.length > 1) {
      preActive = preActive.map(slide => slide.classList.remove(currentSlideClass.replace('.', '')) && slide);
    }
    
    setFirstSlideAsCurrent();

    if (container && grouped === getSlides(container).length) return;
    
    if (currentSlideProgressClass) {
      document.addEventListener('animationend', animationNextSlide); 
      document.addEventListener('animationiteration', animationNextSlide); 
    }

    if (autoSlideTimer && autoSlideTimer > 0) {
      sliderInterval = setInterval(() => {
        [...document.querySelectorAll(containerClass)].map(container => {
          const slides = getSlides(container);
          const currentIndex = getCurrentIndex(slides);
    
          if (slides.length > 1) nextSlide(slides, currentIndex);
        });
      }, autoSlideTimer);
    }

    if (fixHeight) {
      document.addEventListener('DOMContentLoaded', runFixHeight);
      document.addEventListener('vue:loaded', runFixHeight);
      window.addEventListener('resize', runFixHeight);
    }

    swiper = addSwipeEvent();
    
    ['DOMContentLoaded', 'vue:loaded'].map(event => document.addEventListener(event, () => {
      swiper.map(fn => fn.remove());
      swiper = addSwipeEvent();
    }));


    // Check if the slider only contains one element, in which case, hide the progress bar and arrows; 
    [nextClass, prevClass, currentSlideProgressClass, '.carousel__pages'].map(sel => {
      if (container && getSlides(container).length === 1) {
        container.querySelector(sel).style.display = 'none';
      }
    });
    
    [...document.querySelectorAll(containerClass)].map(container => triggerEvent(container, 'slider:loaded'));
  };

  const nextSlideEvent = e => e.target.matches(nextClass) && nextSlideClick(e);
  const prevSlideEvent = e => e.target.matches(prevClass) && previousSlideClick(e);

  const remove = () => {
    // console.log(containerClass, currentSlideClass, [...document.querySelectorAll(`${containerClass} ${slidesClass} ${currentSlideClass}`)].map(slide => slide.classList.remove(currentSlideClass)));
    document.removeEventListener('click', nextSlideEvent);
    document.removeEventListener('click', prevSlideEvent);
    document.removeEventListener('DOMContentLoaded', initialiseSliders);
    document.removeEventListener('animationend', animationNextSlide);
    document.removeEventListener('animationiteration', animationNextSlide);
    document.removeEventListener('DOMContentLoaded', runFixHeight);
    document.removeEventListener('vue:loaded', runFixHeight);
    window.removeEventListener('resize', runFixHeight);
    if (sliderInterval) clearInterval(sliderInterval);
    swiper.map(fn => fn.remove());
    // [...document.querySelectorAll(containerClass)].map(slider => [...slider.querySelectorAll(currentSlideClass)].map(active => active.classList.remove(currentSlideClass.replace('.', ''))));
    return null;
  };

  document.addEventListener('click', nextSlideEvent);
  document.addEventListener('click', prevSlideEvent);
  initialiseSliders();
  document.addEventListener('DOMContentLoaded', initialiseSliders);

  return { remove };
};
